import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  SelectNative,
  SelectNativeOption,
} from '@americanexpress/dls-react';
import { MemberContext } from '../context';

const getVal = require('lodash/get');

/**
 * returns DLS select component
 * @param {*} props
 */
const Select = (props) => {
  const {
    fetchUrl,
    fieldLabel,
    fieldId,
    fieldOptions = [],
    fieldValidation,
    cssProperties,
    selectKey,
    selectShowKey,
    onElementChange = [],
    handleOnChangeEvents,
    showProductInfo,
    fieldDefaultOptionLabel = 'Choose One',
    showValueAsCardNumber = false,
    selectValue,
    filledFormData,
    comments,
  } = props;
  const [options, setOptions] = useState([]);
  const memberContextVal = useContext(MemberContext);
  const customInvalidMsg = fieldValidation && fieldValidation.customInvalidMsg
    ? fieldValidation.customInvalidMsg : 'Please select an item in the list';
  const [value, setValue] = useState('');
  const [fieldIdValue, setFieldIdValue] = useState('');
  useEffect(() => {
    if (fetchUrl) {
      setOptions(memberContextVal);
    } else {
      setOptions(fieldOptions);
    }
  }, []);

  useEffect(() => {
    setFieldIdValue(fieldId);
  }, [fieldId]);

  useEffect(() => {
    if (fieldId !== fieldIdValue) setValue('');
    if (filledFormData && filledFormData[fieldId]) {
      setValue(filledFormData[fieldId]);
    }
  }, [fieldId]);

  const handleSelect = (e) => {
    handleOnChangeEvents(onElementChange, e);
    setValue(e.target.value);
  };

  return (
    <div className={cssProperties.style} data-toggle="select">
      <Label htmlFor={fieldId} className={fieldLabel.cssProperties.style}>
        {fieldLabel.label}<span>  </span>
        {!fieldValidation.required && <span>{' '}(Optional)</span>}
      </Label>
      {fieldLabel
        && fieldLabel.subLabel
        && (
          <div>
            <Label htmlFor={fieldId} className={fieldLabel.cssProperties.subLabelStyle}>
              {fieldLabel.subLabel}
            </Label>
          </div>
        )}
      <div className="select fluid form-control">
        <SelectNative
          name={fieldId}
          id={fieldId}
          aria-label="navigate to"
          //  onChange={(e) => handleOnChangeEvents(onElementChange, e)}
          // onClick={styleSelectedOption}
          value={value}
          onChange={handleSelect}
          required={fieldValidation.required}
          title={customInvalidMsg}
          onInvalid={(e) => e.target.setCustomValidity(`${customInvalidMsg}`)}
          onInput={(e) => e.target.setCustomValidity('')}
        >
          {
            !selectKey && !selectShowKey && Array.isArray(options) ? options.map((option) => (
              <SelectNativeOption
                key={option.value}
                value={option.value}
              >
                {option.label}
              </SelectNativeOption>
            ))
              : (
                /* eslint-disable max-len -- need */
                <>
                  <SelectNativeOption value="" selected={true}>{fieldDefaultOptionLabel}</SelectNativeOption>
                  {
                    !showProductInfo
                      && options && options.length > 0 ? options.map((optionObj) => (
                        <SelectNativeOption
                          key={optionObj[selectKey].accountKey}
                          value={optionObj[selectKey].accountKey}
                        >
                          {optionObj[selectKey][selectShowKey]}
                        </SelectNativeOption>
                      ))
                      /* eslint-disable unicorn/no-nested-ternary -- required T */
                      : !showValueAsCardNumber
                        && options
                        && options.length > 0 ? options.map((optionObj) => (
                          <SelectNativeOption
                            key={
                              selectValue ? optionObj[selectValue] : optionObj[selectKey].accountKey ? optionObj[selectKey].accountKey : optionObj.accountToken
                            }
                            value={
                              selectValue ? optionObj[selectValue] : optionObj[selectKey].accountKey ? optionObj[selectKey].accountKey : optionObj.accountToken
                            }
                          // disabled={optionObj[selectKey][selectShowKey] === selectedOption}
                          >
                            {getVal(optionObj, 'product.digitalInfo.productDesc') ? optionObj.product.digitalInfo.productDesc : ''} (-{optionObj[selectKey][selectShowKey].split('-')[2]})
                          </SelectNativeOption>
                        ))
                        : options && options.length > 0 && options.map((optionObj) => (
                          <SelectNativeOption
                            key={optionObj[selectKey][selectShowKey]}
                            value={optionObj[selectKey][selectShowKey]}
                          >
                            {getVal(optionObj, 'product.digitalInfo.productDesc') ? optionObj.product.digitalInfo.productDesc : ''} (-{optionObj[selectKey][selectShowKey].split('-')[2]})
                          </SelectNativeOption>
                        ))
                    /* eslint-enable unicorn/no-nested-ternary -- required T */
                  }
                </>
                /* eslint-enable max-len -- need */
              )
          }
        </SelectNative>
      </div>
      {
        comments && comments[fieldId]
        && (
          <div id="alert-error" className="alert dls-color-warning pad-1-t">
            <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
            <span>{comments[fieldId].comment}</span>
          </div>
        )
      }
    </div>
  );
};

Select.propTypes = {
  fetchUrl: PropTypes.string,
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  fieldOptions: PropTypes.arrayOf(PropTypes.shape),
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  selectKey: PropTypes.string,
  selectShowKey: PropTypes.string,
  onElementChange: PropTypes.arrayOf(PropTypes.shape),
  handleOnChangeEvents: PropTypes.func,
  showProductInfo: PropTypes.bool,
  fieldDefaultOptionLabel: PropTypes.string,
  showValueAsCardNumber: PropTypes.bool,
  selectValue: PropTypes.string,
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  comments: PropTypes.objectOf(PropTypes.shape),
};

export default Select;
